import { useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { setDraftDialogSecond } from "store/bailiff/draft/dialog/draft_dialog.action";
//
//component
//redux
//selector
//actions
export const TriggerMonitor = ({ audio }) => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();

  // -------------------------- FUNCTIONS ---------------------
  const handleUpdateSecond = useCallback(() => {
    if (!audio) return;
    const currentTime = audio.currentTime;
    const round = parseFloat(currentTime.toFixed(2));
    dispatch(setDraftDialogSecond(round));
  }, [audio, dispatch]);
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (!audio) return;

    audio.addEventListener("timeupdate", handleUpdateSecond);

    return () => {
      audio.removeEventListener("timeupdate", handleUpdateSecond);
    };
  }, [audio, dispatch, handleUpdateSecond]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerMonitor;
